import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { DashboardShell } from "@/components/DashboardShell";
import { PARTNER_NAV } from "@/lib/nav";
import { ServiceActivationWizard } from "@/components/ServiceActivationWizard";
import { SERVICES, useMyServices, type ServiceType } from "@/lib/services";

export const Route = createFileRoute("/_authenticated/partner/services/add")({
  head: () => ({
    meta: [
      { title: "Add a service · Landoo Partner" },
      {
        name: "description",
        content:
          "Activate an additional Landoo partner service with its own verification, agreement and subscription.",
      },
    ],
  }),
  component: AddServicePage,
});

function AddServicePage() {
  const nav = useNavigate();
  const { profiles, refetch } = useMyServices();
  const [selected, setSelected] = useState<ServiceType | null>(null);

  const taken = profiles.map((p) => p.service_type);
  const available = SERVICES.filter((s) => !taken.includes(s.value));

  return (
    <DashboardShell title="Add a service" role="Partner" items={PARTNER_NAV}>
      {!selected ? (
        <>
          <p className="text-sm text-muted-foreground">
            Choose one service to activate. It requires its own registration, verification,
            agreement, subscription and admin approval.
          </p>
          <div className="mt-4 grid gap-3 sm:grid-cols-2">
            {available.map((s) => (
              <button
                key={s.value}
                type="button"
                onClick={() => setSelected(s.value)}
                className="rounded-2xl border border-border bg-card p-5 text-left shadow-soft transition hover:border-brown hover:bg-brand-soft/40"
              >
                <div className="text-base font-bold text-brown-dark">{s.cardTitle}</div>
                <div className="mt-1 text-xs text-muted-foreground">{s.blurb}</div>
              </button>
            ))}
            {available.length === 0 && (
              <div className="rounded-2xl border border-dashed border-border p-4 text-sm text-muted-foreground">
                All four services already have a profile.
              </div>
            )}
          </div>
        </>
      ) : (
        <ServiceActivationWizard
          serviceType={selected}
          onDone={() => {
            void refetch();
            nav({ to: "/partner/services" });
          }}
        />
      )}
    </DashboardShell>
  );
}
